/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Running_SinceInputs */

const fr_vehicle_details_running_since = /** @type {(inputs: Vehicle_Details_Running_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En circulation depuis`)
};

const en_vehicle_details_running_since = /** @type {(inputs: Vehicle_Details_Running_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In service since`)
};

/**
* | output |
* | --- |
* | "In service since" |
*
* @param {Vehicle_Details_Running_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_running_since = /** @type {((inputs?: Vehicle_Details_Running_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Running_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_running_since(inputs)
	return en_vehicle_details_running_since(inputs)
});